import { Stack, Typography } from "@mui/material";
import { PropsWithChildren } from "react";

type VisitEditFormSectionProps = PropsWithChildren<{ title: string }>;

export function VisitEditFormSection({ title, children }: VisitEditFormSectionProps) {
    return (
        <Stack
            gap={2}
            sx={theme => ({
                padding: 3,
                borderTop: `1px solid ${theme.palette.divider}`,
            })}
        >
            {title && <Typography variant="h5">{title}</Typography>}
            {children}
        </Stack>
    );
}
